import '../less/standalone.less';
import React from 'react';
import { TYPE_BRANCHES, TYPE_NBU, TYPE_PROCESSING, TYPE_BUSINESS, TYPE_APP } from "../variables";
import exchangeUsd from "../img/exchange-usd.svg"
import exchangeEuro from "../img/exchange-euro.svg"
import proposalArrow from "../img/exhange-arrow.svg"

export default function template() {
    let {branchCourses, nbuCourses, processingCourses, businessCourses, appCourses} = this.props,
        {type, isMobile, isDesktop} = this.state,
        collection;
    switch (type) {
      case TYPE_BRANCHES:
        collection = branchCourses;
        break;
      case TYPE_NBU:
        collection = nbuCourses;
        break;
      case TYPE_PROCESSING:
        collection = processingCourses;
        break;
      case TYPE_BUSINESS:
        collection = businessCourses;
        break;
      case TYPE_APP:
        collection = appCourses;
        break;
      default:
        collection = null;
    }

    function getTemplate(currencyRate, isMobile = false, isBusiness = false, isMargin = false, rateType = 'rateB') {
      if (!currencyRate) {
        return (
          <div className={`list${isMobile ? '-mobile' : ''}__item__value ${isMargin ? 'list__margin' : ''}`}>
            —
          </div>
        );
      }

      const rate = rateType === 'rateC'
        ? currencyRate.get('rateC')
        : (isBusiness
            ? currencyRate.get('rateB')
            : currencyRate.rateB());

      return (
        <div className={`list${isMobile ? '-mobile' : ''}__item__value ${isMargin ? 'list__margin' : ''}`}>
          {rate ? `${rate.toString(null, null, null, 3)} ₴` : '—'}
        </div>
      );
    }

    let usdUah = collection.get('USD-UAH'),
        eurUah = collection.get('EUR-UAH'),
        uahUsd = collection.get('UAH-USD'),
        uahEur = collection.get('UAH-EUR'),

        rateUSDcommonMobile = getTemplate(usdUah, true, false, false, 'rateB'),
        rateUSDbusinessMobile = getTemplate(uahUsd, true, true, false, 'rateB'),
        rateUSDsellMobile = (type === TYPE_BUSINESS || type === TYPE_APP) ? rateUSDbusinessMobile : rateUSDcommonMobile,

        rateUSDcommon = getTemplate(usdUah, false, false, true, 'rateB'),
        rateUSDbusiness = getTemplate(uahUsd, false, true, true, 'rateB'),
        rateUSDsell = (type === TYPE_BUSINESS || type === TYPE_APP) ? rateUSDbusiness : rateUSDcommon,

        rateEURcommonMobile = getTemplate(eurUah, true, false, false, 'rateB'),
        rateEURbusinessMobile = getTemplate(uahEur, true, true, false, 'rateB'),
        rateEURsellMobile = (type === TYPE_BUSINESS || type === TYPE_APP) ? rateEURbusinessMobile : rateEURcommonMobile,

        rateEURcommon = getTemplate(eurUah, false, false, false, 'rateB'),
        rateEURbusiness = getTemplate(uahEur, false, true, false, 'rateB'),
        rateEURsell = (type === TYPE_BUSINESS || type === TYPE_APP) ? rateEURbusiness : rateEURcommon,

        rateUSDBuyDesktop = getTemplate(uahUsd, false, false, true, 'rateC'),
        rateEURBuyDesktop = getTemplate(uahEur, false, false, false, 'rateC'),

        rateUSDBuyMobile = getTemplate(uahUsd, true, false, false, 'rateC'),
        rateEURBuyMobile = getTemplate(uahEur, true, false, false, 'rateC');

      const types = [ {type: TYPE_BRANCHES, item: this.l10n('NEW_RATES_DROPDOWN_ITEM_1'), title: this.l10n('NEW_RATES_DROPDOWN_TITLE_1'), id: "branches"},
        {type: TYPE_APP, item: this.l10n('NEW_RATES_DROPDOWN_ITEM_2'), title: this.l10n('NEW_RATES_DROPDOWN_TITLE_2'), id: "а24"},
        {type: TYPE_NBU, item: this.l10n('NEW_RATES_DROPDOWN_ITEM_3'), title: this.l10n('NEW_RATES_DROPDOWN_TITLE_3'), id: "nbu"},
        {type: TYPE_PROCESSING, item: this.l10n('NEW_RATES_DROPDOWN_ITEM_4'), title: this.l10n('NEW_RATES_DROPDOWN_TITLE_4'), id: "cards"},
        {type: TYPE_BUSINESS, item: this.l10n('NEW_RATES_DROPDOWN_ITEM_5'), title: this.l10n('NEW_RATES_DROPDOWN_TITLE_5'), id: "business"}
      ];

    return (
        <div className="module-new-rates">
            <div className={`new-rates-dropdown ${this.state.isOpen ? 'new-rates-dropdown-active' : ''}`} ref={this.dropdownRef}>
              <div onClick={this.toggleDropdown} className="new-rates-dropdown-top" onKeyDown={(e) => e.key === 'Enter' && this.toggleDropdown}
                   tabIndex="0">
                <button className="new-rates-dropdown-title">
                  <h3>{types.find(t => t.type === this.state.type)?.title}</h3>
                  <img src={proposalArrow} alt="new-rates-dropdown arrow" className="new-rates-dropdown-arrow"/>
                </button>
              </div>
              <ul className="new-rates-dropdown-list">
                {types
                  .map((item) => (
                    <li
                      key={item.type}
                      onClick={() => this.toggleType(item.type)}
                      onKeyDown={(e) => e.key === 'Enter' && this.toggleType(item.type)}
                      tabIndex="0"
                      className={`new-rates-dropdown-item ${item.type === this.state.type && 'selected'}`}
                      id={`exchangerate-${item.id}`}
                    >
                      {item.item}
                    </li>
                  ))}
              </ul>
            </div>
            {isDesktop && <div className="list__desktop">
              <div className="list__body">
                <div className="list__column">
                  <div className="list__label">{this.l10n('EX_RATES_LABEL_CURRENCY')}</div>
                  <div className="list__row list__margin">
                    <img src={exchangeUsd} alt="usd-image" />
                    <div className="list__item__label">{this.l10n('USD_STRING_NEW')}</div>
                  </div>
                  <div className="list__row">
                    <img src={exchangeEuro} alt="euro-image" />
                    <div className="list__item__label">{this.l10n('EUR_STRING_NEW')}</div>
                  </div>
                </div>
                <div className="list__column">
                  <div className="list__item">
                    <div className="list__label">{this.l10n('EX_RATES_LABEL_BUY')}</div>
                    {rateUSDsell}
                    {rateEURsell}
                  </div>
                  <div className="list__item">
                    <div className="list__label">{this.l10n('EX_RATES_LABEL_SALE')}</div>
                    {rateUSDBuyDesktop}
                    {rateEURBuyDesktop}
                  </div>
                </div>
              </div>
            </div>
            }
            {isMobile && <div className="list__mobile">
              <div className="list-mobile__block">
                <div className="list-mobile__top">
                  <img src={exchangeUsd} alt="euro-image" />
                  <div className="list-mobile__title">{this.l10n('USD_STRING_NEW')}</div>
                </div>
                <div className="list-mobile__bottom">
                  <div className="list-mobile__column">
                    <div className="list-mobile__label">{this.l10n('EX_RATES_LABEL_BUY')}</div>
                    {rateUSDsellMobile}
                  </div>
                  <div className="list-mobile__column">
                    <div className="list-mobile__label">{this.l10n('EX_RATES_LABEL_SALE')}</div>
                    {rateUSDBuyMobile}
                  </div>
                </div>
              </div>
              <div className="list-mobile__block">
                <div className="list-mobile__top">
                  <img src={exchangeEuro} alt="euro-image" />
                  <div className="list-mobile__title">{this.l10n('EUR_STRING_NEW')}</div>
                </div>
                <div className="list-mobile__bottom">
                  <div className="list-mobile__column">
                    <div className="list-mobile__label">{this.l10n('EX_RATES_LABEL_BUY')}</div>
                    {rateEURsellMobile}
                  </div>
                  <div className="list-mobile__column">
                    <div className="list-mobile__label">{this.l10n('EX_RATES_LABEL_SALE')}</div>
                    {rateEURBuyMobile}
                  </div>
                </div>
              </div>
            </div>
            }
        </div>
    );
}
